import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("askt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("askt_token");
      localStorage.removeItem("askt_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/**
 * Stream /api/ask/stream (SSE). Callers pass handlers that fire per event.
 * Returns a promise that resolves when the stream ends.
 *
 * handlers: {
 *   onMeta(data),        // {conversation_id}
 *   onClarifying(data),  // {content, message_id}
 *   onToken(data),       // {text}
 *   onCitations(data),   // {citations: [...]}
 *   onVerifying(data),
 *   onVerified(data),    // {unsupported: [], skipped?: bool}
 *   onCorrection(data),  // {revised_content, citations, unsupported_count}
 *   onDone(data),        // {message_id, answered}
 *   onError(data),       // {detail}
 * }
 */
export async function streamAsk({ question, conversation_id }, handlers, signal) {
  const token = localStorage.getItem("askt_token");
  const res = await fetch(`${API}/ask/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ question, conversation_id }),
    signal,
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    const err = new Error(`stream ${res.status}: ${body.slice(0, 200)}`);
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buf = "";
  const dispatch = (event, data) => {
    const h = handlers && handlers[
      "on" + event.charAt(0).toUpperCase() + event.slice(1)
    ];
    if (h) h(data);
  };
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) !== -1) {
      const block = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      let event = "message";
      let dataStr = "";
      for (const line of block.split("\n")) {
        if (line.startsWith("event: ")) event = line.slice(7).trim();
        else if (line.startsWith("data: ")) dataStr += line.slice(6);
      }
      if (!dataStr) continue;
      let data;
      try { data = JSON.parse(dataStr); } catch { data = dataStr; }
      dispatch(event, data);
    }
  }
}
